/* Skrubbhuset – fri frakt-mätare och uppgradering/tillval i varukorgen (v15)
   - style "calm" (standard): fri frakt-mätaren överst, EN enkel rad med liten produktbild och färgval under produkterna.
     Ordning: 1) en till av skrubbhandduken (paketrabatt), 2) tillval enligt listan "cross" (vanligt rea-pris, ingen extra rabatt),
     3) nästa paket för produkter med paketvarianter (t.ex. fler krokar).
     Efter en uppgradering visas inga fler uppgraderingar (bara ev. ett tillval). Efter ett tillval visas ingen rad.
     Markeringen nollställs när varukorgen töms, och uppgraderingen visas igen om kunden har färre handdukar än efter uppgraderingen.
   - Tillvalets titel och undertext kommer färdigt översatta från sektionen (ordlistan skrubb.i18n, xt_/xs_ + handle).
   - När tillvalet är skrubbhandduken (sektionens Produkt) visas etiketten "Bästsäljare". Inte på uppgraderingsraden.
   - style "bold": den tidigare stora uppgraderingsrutan överst.
   - När kunden använder raden sparas ordermarkeringen "Uppgraderad i varukorgen". */
(function () {
  var dataEl = document.getElementById('sh-cart-boost-data');
  if (!dataEl) return;
  var cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var CALM = cfg.style !== 'bold';
  var T = cfg.t || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || cfg.currency || 'SEK';
  var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
  var wholeOnly = ['SEK', 'DKK', 'NOK', 'ISK'].indexOf(currency) !== -1;
  var loc = (cfg.numLocale || 'sv-SE').slice(0, 2);
  var TBS = {
    sv: { up: 'Uppgradera till {v}', yes: 'Ja, uppgradera +{x}', adding: 'Uppgraderar…', one: 'Köp en till för bara {x}', saves: 'Du sparar {x}', swap: 'Byt till {v} för bara +{x}', add: '+ Lägg till', swapBtn: 'Byt', forx: '{t} för {x}', color: 'Välj färg', best: 'Bästsäljare' },
    da: { up: 'Opgrader til {v}', yes: 'Ja, opgrader +{x}', adding: 'Opgraderer…', one: 'Køb en mere for kun {x}', saves: 'Du sparer {x}', swap: 'Skift til {v} for kun +{x}', add: '+ Tilføj', swapBtn: 'Skift', forx: '{t} for {x}', color: 'Vælg farve', best: 'Bestseller' },
    nb: { up: 'Oppgrader til {v}', yes: 'Ja, oppgrader +{x}', adding: 'Oppgraderer…', one: 'Kjøp en til for bare {x}', saves: 'Du sparer {x}', swap: 'Bytt til {v} for bare +{x}', add: '+ Legg til', swapBtn: 'Bytt', forx: '{t} for {x}', color: 'Velg farge', best: 'Bestselger' },
    fi: { up: 'Vaihda: {v}', yes: 'Kyllä, vaihda +{x}', adding: 'Vaihdetaan…', one: 'Osta toinen vain {x}', saves: 'Säästät {x}', swap: 'Vaihda: {v} vain +{x}', add: '+ Lisää', swapBtn: 'Vaihda', forx: '{t} – {x}', color: 'Valitse väri', best: 'Myydyin' },
    en: { up: 'Upgrade to {v}', yes: 'Yes, upgrade +{x}', adding: 'Upgrading…', one: 'Add one more for just {x}', saves: 'You save {x}', swap: 'Switch to {v} for just +{x}', add: '+ Add', swapBtn: 'Switch', forx: '{t} for {x}', color: 'Choose colour', best: 'Bestseller' }
  };
  var TB = TBS[loc] || TBS.en;
  var ATTR = 'Uppgraderad i varukorgen';
  var ADD_PREFIX = 'Tillägg';
  var DONE = '', DONE_TO = 0;
  var busy = false, clearing = false;
  var timer;
  var pcache = {};

  var threshold = Math.round((cfg.thresholdBase || 0) * 100 * rate);
  var shipFee = Math.round((cfg.shipFee || 0) * 100 * (cfg.tiersBase ? rate : 1));
  var tiers = (cfg.tiers || []).map(function (x) {
    return Math.round(x * 100 * (cfg.tiersBase ? rate : 1));
  });

  function money(c, roundUp) {
    if (wholeOnly && c % 100 !== 0 && roundUp) c = Math.ceil(c / 100) * 100;
    var whole = c % 100 === 0;
    try {
      return new Intl.NumberFormat(cfg.numLocale || 'sv-SE', {
        style: 'currency', currency: currency,
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2
      }).format(c / 100);
    } catch (e) {
      return (c / 100).toFixed(whole ? 0 : 2) + ' ' + currency;
    }
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  }
  function tr(key, vars) {
    var s = T[key] || '';
    Object.keys(vars || {}).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }
  function fill(s, vars) {
    Object.keys(vars || {}).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }
  function num(s) { var m = String(s == null ? '' : s).match(/^\s*(\d+)/); return m ? parseInt(m[1], 10) : 0; }
  function per(total, k) { return Math.round(total / k); }
  function sized(u) {
    if (!u) return '';
    u = String(u);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (u.indexOf('width=') !== -1) return u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }
  function colorName(v) {
    var opts = (v.options || [v.title]).filter(function (o) { return !num(o); });
    return opts.length ? opts.join(' / ') : String(v.title).split(' / ')[0];
  }
  function vImg(v, fallback) { return (v && v.featured_image && (v.featured_image.src || v.featured_image)) || fallback || ''; }
  function colorSelect(list, selId) {
    if (!list || list.length < 2) return '';
    return '<select class="shcb-up__v shcb2__sel" aria-label="' + esc(TB.color) + '">' + list.map(function (o) {
      return '<option value="' + o.id + '" data-img="' + esc(sized(o.img)) + '"' + (o.id === selId ? ' selected' : '') + '>' + esc(o.name) + '</option>';
    }).join('') + '</select>';
  }
  /* Målantal i markeringen, t.ex. "2 → 3 st" -> 3 */
  function targetOf(label) { var m = String(label || '').match(/→\s*(\d+)/); return m ? parseInt(m[1], 10) : 0; }
  /* '' = inget gjort, 'up' = har uppgraderat, 'add' = har lagt till ett tillval */
  function doneInfo(cart) {
    if (DONE) return { mode: DONE, to: DONE_TO };
    var a = (cart && cart.attributes && cart.attributes[ATTR]) || '';
    if (!a) return { mode: '', to: 0 };
    return { mode: String(a).indexOf(ADD_PREFIX) === 0 ? 'add' : 'up', to: targetOf(a) };
  }

  function shipBar(total) {
    if (threshold <= 0) return '';
    if (total >= threshold) {
      return '<div class="shcb__ship shcb__ship--ok"><span class="shcb__ico" aria-hidden="true">✓</span><span>' + tr('ship_ok') + '</span></div>' +
        '<div class="shcb__bar" aria-hidden="true"><div class="shcb__fill" style="width:100%"></div></div>';
    }
    var pct = Math.max(6, Math.min(100, Math.round((total / threshold) * 100)));
    return '<div class="shcb__ship"><span class="shcb__ico" aria-hidden="true">🚚</span><span>' +
      tr('ship_left', { x: '<strong>' + money(threshold - total, true) + '</strong>' }) + '</span></div>' +
      '<div class="shcb__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><div class="shcb__fill" style="width:' + pct + '%"></div></div>';
  }

  function getProduct(handle) {
    if (pcache[handle] !== undefined) return Promise.resolve(pcache[handle]);
    return fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { pcache[handle] = p; return p; })
      .catch(function () { pcache[handle] = null; return null; });
  }

  function packIndex(p) {
    if (!p || !p.variants || !p.variants.length) return -1;
    var n = p.variants[0].options.length;
    for (var k = 0; k < n; k++) {
      var all = p.variants.every(function (v) { return num(v.options[k]) > 0; });
      var distinct = {};
      p.variants.forEach(function (v) { distinct[num(v.options[k])] = 1; });
      if (all && Object.keys(distinct).length > 1) return k;
    }
    return -1;
  }

  function offerFor(item, p) {
    var idx = packIndex(p);
    if (idx < 0) return null;
    var cur = null;
    p.variants.forEach(function (v) { if (v.id === item.variant_id) cur = v; });
    if (!cur) return null;
    var curN = num(cur.options[idx]);
    if (!curN) return null;
    var best = null;
    p.variants.forEach(function (v) {
      if (!v.available || v.id === cur.id) return;
      var n = num(v.options[idx]);
      if (n <= curN) return;
      for (var k = 0; k < v.options.length; k++) { if (k !== idx && v.options[k] !== cur.options[k]) return; }
      if (!best || n < num(best.options[idx])) best = v;
    });
    if (!best) return null;
    var q = item.quantity;
    var newN = num(best.options[idx]);
    var add = (best.price - cur.price) * q;
    if (add <= 0) return null;
    var save = Math.max(0, Math.round(cur.price / curN * newN - best.price)) * q;
    var img = (best.featured_image && best.featured_image.src) || item.image || p.featured_image;
    return { from: cur.id, to: best.id, qty: q, label: best.options[idx], fromLabel: cur.options[idx], add: add, save: save, unitNow: per(cur.price, curN), unitNew: per(best.price, newN), image: img };
  }

  function findBundleOffer(cart) {
    var items = (cart.items || []).filter(function (i) {
      return (i.options_with_values || []).some(function (o) { return num(o.value) > 0; });
    });
    if (!items.length) return Promise.resolve(null);
    return items.reduce(function (chain, item) {
      return chain.then(function (found) {
        if (found) return found;
        return getProduct(item.handle).then(function (p) { return offerFor(item, p); });
      });
    }, Promise.resolve(null));
  }

  function findCross(cart) {
    var rules = cfg.cross || [];
    if (!CALM || !rules.length || !cart || !cart.items || !cart.items.length) return Promise.resolve(null);
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.handle] = 1; });
    var rule = null;
    for (var i = 0; i < cart.items.length && !rule; i++) {
      var h = cart.items[i].handle;
      for (var k = 0; k < rules.length; k++) {
        if ((rules[k].from === h || rules[k].from === '*') && !inCart[rules[k].to]) { rule = rules[k]; break; }
      }
    }
    if (!rule) return Promise.resolve(null);
    return getProduct(rule.to).then(function (p) {
      if (!p || !p.available) return null;
      var av = p.variants.filter(function (v) { return v.available; });
      if (!av.length) return null;
      var minP = Math.min.apply(null, av.map(function (v) { return v.price; }));
      var same = av.filter(function (v) { return v.price === minP; });
      var v = same[0];
      var colors = same.map(function (x) { return { id: x.id, name: colorName(x), img: vImg(x, p.featured_image) }; });
      return { id: v.id, price: v.price, compare: v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0, img: vImg(v, p.featured_image), colors: colors,
        title: rule.title || p.title, sub: rule.sub || '', best: !!(cfg.product && cfg.product.handle === rule.to), track: ADD_PREFIX + ': ' + (rule.title || p.title) };
    });
  }

  function calmRow(text, sub, btnHtml, img, sel) {
    var pic = img ? '<img class="shcb2__img" src="' + esc(sized(img)) + '" alt="" width="48" height="48" loading="lazy">' : '';
    var txt = '<div class="shcb2__txt">' + text + (sub ? '<span class="shcb2__s">' + esc(sub) + '</span>' : '') + '</div>';
    if (sel) return '<div class="shcb2 shcb2--sel" role="group"><div class="shcb2__top">' + pic + txt + '</div><div class="shcb2__act">' + sel + btnHtml + '</div></div>';
    return '<div class="shcb2" role="group">' + pic + txt + btnHtml + '</div>';
  }
  function crossRow(x) {
    var price = '<b>' + esc(money(x.price)) + '</b>' + (x.compare ? ' <s class="shcb2__c">' + esc(money(x.compare)) + '</s>' : '');
    var sel = colorSelect(x.colors, x.id);
    var hidden = sel ? '' : '<input type="hidden" class="shcb-up__v" value="' + x.id + '">';
    var badge = x.best ? '<span class="shcb2__best">' + esc(TB.best) + '</span>' : '';
    return calmRow(badge + fill(esc(TB.forx), { t: esc(x.title), x: price }), x.sub,
      hidden + '<button type="button" class="shcb-up__add shcb2__btn" data-track="' + esc(x.track) + '">' + esc(TB.add) + '</button>', x.img, sel);
  }

  function bundleCard(cart, o) {
    var total = cart.total_price;
    var freeShip = threshold > 0 && total < threshold && total + o.add >= threshold;
    var net = freeShip && shipFee > 0 ? Math.max(0, o.add - shipFee) : o.add;
    var btnData = ' data-from="' + o.from + '" data-to="' + o.to + '" data-qty="' + o.qty + '" data-track="' + esc(o.fromLabel + ' → ' + o.label) + '"';
    if (CALM) {
      var s = o.save > 0 ? fill(TB.saves, { x: money(o.save) }) : '';
      return calmRow(esc(fill(TB.swap, { v: o.label, x: '' })).replace(/\+$/, '') + '<b>+' + esc(money(o.add)) + '</b>', s,
        '<button type="button" class="shcb-up__add shcb2__btn"' + btnData + '>' + esc(TB.swapBtn) + '</button>', o.image);
    }
    var headline = net < o.add
      ? tr('net', { x: '<strong>' + money(net) + '</strong>' })
      : tr('only', { x: '<strong>' + money(o.add) + '</strong>' });
    var sub = net < o.add ? tr('net_sub', { x: money(shipFee) }) : (freeShip ? tr('free_order') : '');
    var title = fill(TB.up, { v: o.label });
    var img = o.image ? (String(o.image).indexOf('//') === 0 ? 'https:' + o.image : o.image) : '';
    return '<div class="shcb-up" role="group" aria-label="' + esc(title) + '">' +
      (o.save > 0 ? '<span class="shcb-up__badge">' + esc(tr('save', { x: money(o.save) })) + '</span>' : '') +
      '<div class="shcb-up__row">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="64" height="64">' : '') +
        '<div class="shcb-up__info">' +
          '<p class="shcb-up__t">' + esc(title) + '</p>' +
          '<p class="shcb-up__unit"><s>' + money(o.unitNow) + tr('per') + '</s> <span aria-hidden="true">→</span> <strong>' + money(o.unitNew) + tr('per') + '</strong></p>' +
        '</div>' +
      '</div>' +
      '<div class="shcb-up__deal"><p class="shcb-up__net">' + headline + '</p>' +
        (sub ? '<p class="shcb-up__sub">' + esc(sub) + '</p>' : '') + '</div>' +
      '<div class="shcb-up__act">' +
        '<button type="button" class="shcb-up__add"' + btnData + '>' + esc(fill(TB.yes, { x: money(o.add) })) + '</button></div>' +
    '</div>';
  }

  function build(cart, offer, cross) {
    var out = { top: '', bottom: '' };
    if (!cart || cart.item_count === 0) return out;
    var total = cart.total_price;
    out.top = shipBar(total);

    var p = cfg.product;
    var qty = 0, firstVariant = null, lastVariant = null, lastImg = '', imgByV = {};
    if (p) cart.items.forEach(function (i) {
      if (i.handle === p.handle) { qty += i.quantity; if (!firstVariant) firstVariant = i.variant_id; lastVariant = i.variant_id; lastImg = i.image || lastImg; if (i.image) imgByV[i.variant_id] = i.image; }
    });

    var info = doneInfo(cart);
    if (info.mode === 'add') return out;
    var allowUp = info.mode !== 'up' || (info.to > 0 && qty > 0 && qty < info.to);

    /* 1) En till av skrubbhandduken */
    if (allowUp && p && qty > 0 && !offer) {
      var avail = p.variants.filter(function (v) { return v.available; });
      if (avail.length) {
        var minP = Math.min.apply(null, avail.map(function (v) { return v.price; }));
        avail = avail.filter(function (v) { return v.price === minP; });
        var unit = avail[0].price;
        var tl = tiers;
        if ((!tl || tl.length < 2) && cfg.discounts && cfg.discounts.length > 1) {
          var r = (cfg.shopCurrency && cfg.shopCurrency !== currency) ? rate : 1;
          tl = cfg.discounts.map(function (d, i) { return unit * (i + 1) - Math.round(d * 100 * r); });
        }
        if (tl && tl.length >= 2 && qty < tl.length) {
          var add = tl[qty] - tl[qty - 1];
          if (add > 0) {
            var n = qty + 1, save = Math.max(0, unit - add), trk = qty + ' → ' + n + ' st';
            if (CALM) {
              var keep = lastVariant || firstVariant || avail[0].id;
              var tcolors = avail.map(function (v) { return { id: v.id, name: String(v.title).split(' / ')[0], img: v.image || imgByV[v.id] || p.image }; });
              var tsel = colorSelect(tcolors, keep);
              var thidden = tsel ? '' : '<input type="hidden" class="shcb-up__v" value="' + keep + '">';
              out.bottom = calmRow(esc(fill(TB.one, { x: '' })) + '<b>' + esc(money(add)) + '</b>', save > 0 ? fill(TB.saves, { x: money(save) }) : '',
                thidden + '<button type="button" class="shcb-up__add shcb2__btn" data-track="' + esc(trk) + '">' + esc(TB.add) + '</button>', lastImg || p.image, tsel);
              return out;
            }
            var options = avail.map(function (v) { return '<option value="' + v.id + '"' + (v.id === firstVariant ? ' selected' : '') + '>' + esc(String(v.title).split(' / ')[0]) + '</option>'; }).join('');
            var picker = avail.length > 1 ? '<select class="shcb-up__v" aria-label="' + esc(tr('color')) + '">' + options + '</select>' : '<input type="hidden" class="shcb-up__v" value="' + avail[0].id + '">';
            var unitNow = per(tl[qty - 1], qty), unitNew = per(tl[qty], n);
            var freeShip = threshold > 0 && total < threshold && total + add >= threshold;
            var net = freeShip && shipFee > 0 ? Math.max(0, add - shipFee) : add;
            var proof = (qty === 1 && T.proof) ? T.proof : '';
            var headline = net < add ? tr('net', { x: '<strong>' + money(net) + '</strong>' }) : tr('only', { x: '<strong>' + money(add) + '</strong>' });
            var sub = net < add ? tr('net_sub', { x: money(shipFee) }) : (freeShip ? tr('free_order') : '');
            out.top += '<div class="shcb-up" role="group" aria-label="' + esc(tr('upgrade', { n: n })) + '">' +
              (save > 0 ? '<span class="shcb-up__badge">' + esc(tr('save', { x: money(save) })) + '</span>' : '') +
              '<div class="shcb-up__row">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="64" height="64">' : '') +
                '<div class="shcb-up__info"><p class="shcb-up__t">' + esc(tr('upgrade', { n: n })) + '</p>' +
                '<p class="shcb-up__unit"><s>' + money(unitNow) + tr('per') + '</s> <span aria-hidden="true">→</span> <strong>' + money(unitNew) + tr('per') + '</strong></p></div></div>' +
              '<div class="shcb-up__deal"><p class="shcb-up__net">' + headline + '</p>' + (sub ? '<p class="shcb-up__sub">' + esc(sub) + '</p>' : '') + '</div>' +
              (proof ? '<p class="shcb-up__proof"><span aria-hidden="true">★★★★★</span> ' + esc(proof) + '</p>' : '') +
              '<div class="shcb-up__act">' + picker + '<button type="button" class="shcb-up__add" data-track="' + esc(trk) + '">' + esc(tr('yes', { n: n, x: money(add) })) + '</button></div>' +
            '</div>';
            return out;
          }
        }
      }
    }

    /* 2) Tillval (lugnt läge) */
    if (CALM && cross) { out.bottom = crossRow(cross); return out; }

    /* 3) Nästa paket (t.ex. fler krokar) */
    if (allowUp && offer) { if (CALM) out.bottom = bundleCard(cart, offer); else out.top += bundleCard(cart, offer); return out; }

    /* Stort läge: rekommendera skrubbhandduken om den saknas */
    if (!CALM && p && qty === 0) {
      var av2 = p.variants.filter(function (v) { return v.available; });
      if (av2.length) {
        var mp = Math.min.apply(null, av2.map(function (v) { return v.price; }));
        av2 = av2.filter(function (v) { return v.price === mp; });
        var opts = av2.map(function (v) { return '<option value="' + v.id + '">' + esc(String(v.title).split(' / ')[0]) + '</option>'; }).join('');
        var pk = av2.length > 1 ? '<select class="shcb-up__v" aria-label="' + esc(tr('color')) + '">' + opts + '</select>' : '<input type="hidden" class="shcb-up__v" value="' + av2[0].id + '">';
        out.top += '<div class="shcb-up shcb-up--plain"><div class="shcb-up__row">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="64" height="64">' : '') +
          '<div class="shcb-up__info"><p class="shcb-up__t">' + esc(tr('heading')) + '</p><p class="shcb-up__unit"><strong>' + money(mp) + '</strong></p></div></div>' +
          '<div class="shcb-up__act">' + pk + '<button type="button" class="shcb-up__add">' + esc(tr('add')) + '</button></div></div>';
      }
    }
    return out;
  }

  function host() {
    var d = document.querySelector('cart-drawer');
    return d ? d.querySelector('cart-drawer-items') : null;
  }

  function place(id, cls, html, h, atTop) {
    var box = document.getElementById(id);
    if (!html) { if (box) box.remove(); return; }
    if (!box || !h.contains(box)) {
      if (box) box.remove();
      box = document.createElement('div');
      box.id = id; box.className = cls;
      if (atTop) h.insertBefore(box, h.firstChild); else h.appendChild(box);
    }
    if (box.getAttribute('data-k') !== html) { box.innerHTML = html; box.setAttribute('data-k', html); }
  }

  function mount(cart, offer, cross) {
    var h = host();
    if (!h) return;
    var o = build(cart, offer, cross);
    place('shcb', 'shcb' + (CALM ? ' shcb--calm' : ''), o.top, h, true);
    place('shcb2', 'shcb2-wrap', o.bottom, h, false);
  }

  /* Tömd varukorg: nollställ markeringen så att nästa köp börjar från början */
  function resetIfEmpty(c) {
    if (!c || c.item_count !== 0) return;
    DONE = ''; DONE_TO = 0;
    if (clearing || !(c.attributes && c.attributes[ATTR])) return;
    clearing = true;
    var attrs = {}; attrs[ATTR] = '';
    fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .catch(function () {}).then(function () { clearing = false; });
  }

  function refresh() {
    if (busy) return;
    busy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        resetIfEmpty(c);
        return Promise.all([findBundleOffer(c), findCross(c)]).then(function (res) { busy = false; mount(c, res[0], res[1]); });
      })
      .catch(function () { busy = false; });
  }

  function soon() { clearTimeout(timer); timer = setTimeout(refresh, 150); }

  function onlyOurs(m) {
    var a = document.getElementById('shcb'), b = document.getElementById('shcb2');
    if ((a && a.contains(m.target)) || (b && b.contains(m.target))) return true;
    var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
    return nodes.length > 0 && nodes.every(function (n) { return n.id === 'shcb' || n.id === 'shcb2'; });
  }

  function track(label) {
    if (!label) return Promise.resolve();
    if (String(label).indexOf(ADD_PREFIX) === 0) { DONE = 'add'; }
    else { DONE = DONE === 'add' ? 'add' : 'up'; DONE_TO = targetOf(label); }
    var attrs = {}; attrs[ATTR] = label;
    return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
  }

  function afterChange(drawer, res, variantId) {
    if (drawer && drawer.renderContents && res.sections) {
      res.id = variantId;
      drawer.renderContents(res);
    } else {
      window.location.href = root + 'cart';
      return;
    }
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sh-cart-boost' });
    }
    soon();
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('.shcb2__sel');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var img = sel.closest('.shcb2') && sel.closest('.shcb2').querySelector('.shcb2__img');
    if (img && opt && opt.getAttribute('data-img')) img.src = opt.getAttribute('data-img');
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.shcb-up__add');
    if (!btn) return;
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    var label = btn.textContent;
    var trk = btn.getAttribute('data-track');

    if (btn.hasAttribute('data-to')) {
      var from = btn.getAttribute('data-from'), to = Number(btn.getAttribute('data-to')), q = Number(btn.getAttribute('data-qty')) || 1;
      var updates = {}; updates[from] = 0; updates[to] = q;
      btn.disabled = true; btn.textContent = TB.adding;
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: sections, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { btn.disabled = false; btn.textContent = label; return; }
          track(trk || 'Paket').then(function () { afterChange(drawer, res, to); });
        })
        .catch(function () { btn.disabled = false; btn.textContent = label; });
      return;
    }

    var box = btn.closest('.shcb2') || document.getElementById('shcb');
    var input = box && box.querySelector('.shcb-up__v');
    if (!input) return;
    btn.disabled = true;
    btn.textContent = tr('adding');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { btn.disabled = false; btn.textContent = label; return; }
        track(trk || 'Uppgradering').then(function () { afterChange(drawer, res, Number(input.value)); });
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  });

  function css() {
    if (document.getElementById('shcb2-css')) return;
    var s = document.createElement('style'); s.id = 'shcb2-css';
    s.textContent = '.shcb2__img{width:48px;height:48px;flex:0 0 48px;border-radius:10px;object-fit:cover;background:#fff;border:1px solid #E3E8EF}' +
      '.shcb2.shcb2--sel{flex-direction:column;align-items:stretch;gap:12px}' +
      '.shcb2__top{display:flex;align-items:center;gap:14px}' +
      '.shcb2__act{display:flex;gap:10px;align-items:center}' +
      '.shcb2__best{display:table;margin:0 0 5px;padding:3px 9px;border-radius:999px;background:#1F3A5F;color:#fff;font-size:11.5px;font-weight:700;letter-spacing:.03em;line-height:1.35;text-transform:uppercase}' +
      '.shcb2__sel{flex:1 1 auto;min-width:0;height:50px;padding:0 36px 0 14px;border:1.5px solid #cfd6e0;border-radius:12px;background:#fff url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 8%27%3E%3Cpath d=%27M1 1l5 5 5-5%27 fill=%27none%27 stroke=%27%231F3A5F%27 stroke-width=%272%27/%3E%3C/svg%3E") no-repeat right 14px center/12px 8px;-webkit-appearance:none;appearance:none;font:inherit;font-size:16px;color:#111827}' +
      '.shcb2__sel:focus{outline:2px solid #1F3A5F;outline-offset:1px}' +
      '.shcb2--sel .shcb2__btn{flex:0 0 auto}';
    document.head.appendChild(s);
  }

  function init() {
    css();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function (muts) {
        if (muts.every(onlyOurs)) return;
        soon();
      }).observe(drawer, { childList: true, subtree: true });
    }
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, soon);
    }
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
